import axios from 'axios';
import { ENV } from '@configs/env';

export const refreshToken = async (refreshTokenValue, setAuthState, logout) => {
    try {
        if (!refreshTokenValue) throw new Error('Missing refresh token');

        const bareAPI = axios.create({
            baseURL: ENV.API_URL,
            headers: {
                'x-refresh-token': refreshTokenValue,
                'Content-Type': 'application/json'
            }
        });

        const response = await bareAPI.post('/auth/refresh', {
            refreshToken: refreshTokenValue
        });

        const responseData = response.data.data || response.data;
        const { user, accessToken, refreshToken: newRefresh } = responseData;

        setAuthState({
            user: user || null,
            role: user?.role || null,
            permissions: user?.permissions || [],
            isAuthenticated: true,
            accessToken,
            refreshToken: newRefresh
        });

        return {
            accessToken,
            refreshToken: newRefresh
        };
    } catch {
        logout();
        return null;
    }
};
